import * as Yup from 'yup';

const RecoverSchema = Yup.object().shape({
  email: Yup.string().email("E-mail inválido").required("Obrigatório"),
});


export {
  RecoverSchema
}